import { useState } from "react";
import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

const getTitleUUID = createUUID();
const updateTitleUUID = createUUID();

export function useTitleDetailsViewModel() {
  const [title, setTitle] = useState(null);
  const stateManager = useComponentState();

  const getTitle = (id) => {
    stateManager.abort(getTitleUUID);
    stateManager.run(async () => {
      const titleResponse = await subscriptionService.titles.get(id);

      if (titleResponse.status === HTTP_STATUSES.OK) {
        setTitle(titleResponse.data);
      }
    }, getTitleUUID);
  };

  const updateTitle = (id, data, callback) => {
    stateManager.abort(updateTitleUUID);
    stateManager.run(async () => {
      const response = await subscriptionService.titles.update({
        id,
        data,
        toastMessageConfig: {
          success: { text: "Title updated successfully!" },
          failure: { text: "Failed to update title!" },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        callback();
      }
    }, updateTitleUUID);
  };

  return {
    getTitle,
    title,
    updateTitle,
    stateManager,
  };
}
